export default {
  init() {
    this.heroSlider();
  },

  /**
   * Simple fade-in-out slider
   */
  heroSlider (){
    let current = 0;
    const slides = document.querySelectorAll('.hero__slider__slide');
    // Wait a bit for for the first slide, while the page is loading
    setTimeout(() => {
      setInterval(function() {
        for (var i = 0; i < slides.length; i++) {
          slides[i].style.opacity = 0;
        }
        current = (current != slides.length - 1) ? current + 1 : 0;
        slides[current].style.opacity = 1;
      }, 4000);
    }, 1000);
  },
};
